import { RequestStatus } from 'features/request/requestSlice';
import { useRequest } from 'features/request/useRequest';
import { useResetStoreData } from 'features/request/useResetStoreData';
import type { BimPriceLevelEnum } from 'gql/graphql';
import type { BimActKc2DataVersionExtended } from 'pages/Project/BimProject/WorkOrder/BimWorkOrderActsKc2/types';

import { useCallback, useEffect, useMemo } from 'react';
import { useDispatch } from 'react-redux';

import { bimActsKC2VersionGql } from '../../bimWorkOrderPriceVersionTabelQueries';

const requestId = 'bimActsKC2Version';

export const useBimVersionActsKC2 = (
    workOrderVersionPriceId: number,
    priceLevel: BimPriceLevelEnum | undefined,
    isVersionPage?: boolean,
) => {
    const dispatch = useDispatch();

    const variables = useMemo(
        () => ({
            workOrderVersionPriceId,
            priceLevel,
        }),
        [priceLevel, workOrderVersionPriceId],
    );

    const [resetBimActsKc2Data] = useResetStoreData({
        requestId,
    });

    const [bimActsKc2Data, bimActsKc2Status, , bimActsKc2MakeRequest] = useRequest({
        requestId,
        query: bimActsKC2VersionGql,
        withEffect: !!workOrderVersionPriceId && !!isVersionPage,
        variables,
    });

    useEffect(
        () => () => {
            resetBimActsKc2Data(undefined);
        },
        [resetBimActsKc2Data],
    );

    const refresh = useCallback(() => {
        dispatch(bimActsKc2MakeRequest(variables));
    }, [bimActsKc2MakeRequest, dispatch, variables]);

    const data = useMemo(
        () =>
            bimActsKc2Data?.bimActsKC2Version?.items?.reduce((acc: BimActKc2DataVersionExtended[], item) => {
                acc.push({ ...item, isActRow: true });

                return acc;
            }, []) || [],
        [bimActsKc2Data?.bimActsKC2Version?.items],
    );

    const isLoading = bimActsKc2Status === RequestStatus.FETCHING;

    return { data, isLoading, refresh };
};
